import React, { useState } from 'react';
import { MDBIcon } from 'mdb-react-ui-kit';


function PasswordInputField({
  handlePasswordChange,
  passwordValue,
  passwordStrength,
}) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prevState) => !prevState);
  };

  return (
<div>
   <label className="form-label">Password<span className="text-danger">*</span></label>
   <div className="IconContainer">
     <input
      type={isPasswordVisible ? "text" : "password"}
      className="form-control"
      placeholder="Password"
      autoComplete="new-password"
      onChange={handlePasswordChange}
      onInput={passwordStrength}
      value={passwordValue}
      id="typePasswordX-2"
      required />
     <MDBIcon fas icon={isPasswordVisible ? "eye-slash" : "eye"} className="inputIcon" onClick={togglePasswordVisibility} />
   </div>
  </div>
  );
}

export default PasswordInputField;
